"use client";

import { cn } from "@/lib/utils";

/** Lớp trang trí nền header / sidebar — tone rose 20/10, không chặn tương tác. */
export function WomensDayHeaderDecor({ className }: { className?: string }) {
  return (
    <div
      className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)}
      aria-hidden
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_12%_0%,rgba(244,63,94,0.22),transparent_55%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_88%_0%,rgba(251,113,133,0.14),transparent_50%)]" />
      <div className="absolute -left-8 top-1/2 h-24 w-24 -translate-y-1/2 animate-[pulse_4s_ease-in-out_infinite] rounded-full bg-rose-400/15 blur-2xl" />
      <div className="absolute -right-6 top-0 h-20 w-20 animate-[pulse_5s_ease-in-out_infinite_0.7s] rounded-full bg-pink-400/12 blur-2xl" />

      <svg
        className="absolute left-[7%] top-1.5 hidden h-9 w-9 text-rose-400/35 sm:block"
        viewBox="0 0 40 40"
        fill="currentColor"
      >
        <path d="M20 6c3 5 2 9-1 12 4-1 8 2 9 6-4-1-8 1-10 4 1-4-1-8-5-10 3 0 5-4 7-12z" />
        <circle cx="20" cy="20" r="2.2" opacity=".55" />
      </svg>
      <svg
        className="absolute right-[8%] top-2 hidden h-7 w-7 text-rose-300/30 md:block"
        viewBox="0 0 40 40"
        fill="currentColor"
      >
        <path d="M20 8c2 4 1.5 7-.5 9 3-.5 6 1.5 7 5-3-1-6 .5-8 3 .5-3.5-1-7-4-8.5 2.5 0 4-3.5 5.5-8.5z" opacity=".85" />
      </svg>

      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-rose-400/55 to-transparent" />
    </div>
  );
}

export function WomensDaySeasonBadge({ compact, className }: { compact?: boolean; className?: string }) {
  if (compact) {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1 rounded border border-rose-400/40 bg-rose-500/15 px-2 py-0.5 text-[10px] font-semibold text-rose-200",
          className
        )}
      >
        20/10 · Phụ nữ VN
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded border border-rose-400/35 bg-gradient-to-r from-rose-500/20 to-pink-500/15 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-rose-100",
        className
      )}
    >
      Ngày Phụ nữ Việt Nam
    </span>
  );
}
